import styled from 'styled-components'

const InterestingFactStyle = styled.div`
	--heroImagePaddingTop: var(--sp138x);
	--interestingFactMarginBottom: var(--sp8x);
	--interestingFactContentDescriptionMarginTop: var(--sp7x);
	--interestingFactContentButtonMarginTop: var(--sp8x);
	--interestingFactContentMaxWidth: var(--sp134x);
	--interestingFactContentPaddingH: var(--sp13x);
	--interestingFactContentPaddingV: var(--sp13x);
	--interestingFactContentBorderRadius: var(--sp3x);

	display: flex;
	align-items: center;
	top: 0;
	height: var(--heroImagePaddingTop);
	margin-bottom: var(--interestingFactMarginBottom);

	&.reversed {
		.interesting-fact-content {
			margin-left: auto;
		}
	}

    &.section {
        --interestingFactMarginBottom: 0;
    }

	.interesting-fact-image {
		position: absolute;
		width: 100%;
		padding-top: var(--heroImagePaddingTop);
	}

	.interesting-fact-content {
		max-width: var(--interestingFactContentMaxWidth);
		padding: var(--interestingFactContentPaddingV) var(--interestingFactContentPaddingH);
		background-color: var(--primaryColor3);
		position: relative;
		border-radius: var(--interestingFactContentBorderRadius);
		z-index: 1;

		.interesting-fact-content-description {
			margin-top: var(--interestingFactContentDescriptionMarginTop);\
		}

        .interesting-fact-button {
            margin-top: var(--interestingFactContentButtonMarginTop);
        }
	}


	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--heroImagePaddingTop: var(--sp104x);
		--interestingFactMarginBottom: var(--sp7x);
		--interestingFactContentDescriptionMarginTop: var(--sp5x);
		--interestingFactContentButtonMarginTop: var(--sp7x);
		--interestingFactContentMaxWidth: var(--sp107x);
		--interestingFactContentPaddingH: var(--sp10x);
	    --interestingFactContentPaddingV: var(--sp10x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--heroImagePaddingTop: var(--sp82x);
		--interestingFactMarginBottom: var(--sp6x);
		--interestingFactContentDescriptionMarginTop: var(--sp4x);
		--interestingFactContentButtonMarginTop: var(--sp6x);
		--interestingFactContentMaxWidth: var(--sp80x);
		--interestingFactContentPaddingH: var(--sp8x);
	    --interestingFactContentPaddingV: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--heroImagePaddingTop: var(--sp78x);
		--interestingFactMarginBottom: var(--sp6x);
		--interestingFactContentDescriptionMarginTop: var(--sp4x);
		--interestingFactContentButtonMarginTop: var(--sp6x);
		--interestingFactContentMaxWidth: var(--sp80x);
		--interestingFactContentPaddingH: var(--sp8x);
	    --interestingFactContentPaddingV: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--heroImagePaddingTop: var(--sp69x);
		--interestingFactMarginBottom: var(--sp5x);
		--interestingFactContentDescriptionMarginTop: var(--sp4x);
		--interestingFactContentButtonMarginTop: var(--sp5x);
		--interestingFactContentMaxWidth: var(--sp69x);
		--interestingFactContentPaddingH: var(--sp7x);
	    --interestingFactContentPaddingV: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--heroImagePaddingTop: var(--sp55x);
		--interestingFactMarginBottom: var(--sp4x);
		--interestingFactContentDescriptionMarginTop: var(--sp3x);
		--interestingFactContentButtonMarginTop: var(--sp5x);
		--interestingFactContentMaxWidth: var(--sp60x);
		--interestingFactContentPaddingH: var(--sp5x);
	    --interestingFactContentPaddingV: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--heroImagePaddingTop: var(--sp55x);
		--interestingFactMarginBottom: var(--sp4x);
		--interestingFactContentDescriptionMarginTop: var(--sp3x);
		--interestingFactContentButtonMarginTop: var(--sp5x);
		--interestingFactContentMaxWidth: var(--sp60x);
		--interestingFactContentPaddingH: var(--sp5x);
	    --interestingFactContentPaddingV: var(--sp5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--heroImagePaddingTop: var(--sp52x);
		--interestingFactMarginBottom: var(--sp3x);
		--interestingFactContentDescriptionMarginTop: var(--sp2x);
		--interestingFactContentButtonMarginTop: var(--sp3x);
		--interestingFactContentMaxWidth: 100%;
		--interestingFactContentPaddingH: var(--sp3x);
	    --interestingFactContentPaddingV: var(--sp3x);
	}
`

export default InterestingFactStyle
